// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ProductCodeService = {};

ProductCodeService.getProductCodeList = function (userInput) {
  return lossClient({
    url: "/producttype/Items?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

ProductCodeService.getProductType = function (userInput) {
  return lossClient({
    url: "/producttype/Items?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default ProductCodeService;
